const Anchor = (props) => {
    const anchortarget = props.target ? props.target : '_blank';

    return (
        <a href={props.url} rel="noreferrer" target={anchortarget} dangerouslySetInnerHTML={{__html: props.label ? props.label : props.url}}></a>
    )
}

export default Anchor;